import React, { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

interface PlatformProtectedRouteProps {
  children: React.ReactNode;
}

export const PlatformProtectedRoute: React.FC<PlatformProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const [isSuperAdmin, setIsSuperAdmin] = useState<boolean | null>(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkSuperAdmin = async () => {
      if (!user) {
        setIsSuperAdmin(false);
        setChecking(false);
        return;
      }

      try {
        const { data, error } = await supabase.rpc('is_super_admin');
        if (error) throw error;
        setIsSuperAdmin(data || false);
      } catch (error) {
        console.error('Ошибка проверки прав супер-администратора:', error);
        setIsSuperAdmin(false);
      } finally {
        setChecking(false);
      }
    };

    checkSuperAdmin();
  }, [user]);

  if (loading || checking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p className="text-muted-foreground">Проверка прав доступа...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/platform/login" replace />;
  }

  if (!isSuperAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4 max-w-md">
          <h1 className="text-2xl font-bold text-destructive">Доступ запрещен</h1>
          <p className="text-muted-foreground">
            У вас нет прав для доступа к платформенной администрации.
          </p>
          <a 
            href="/platform/login" 
            className="inline-block px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            Вернуться к входу
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};